<template>
  <div><input type="text" :id="this.elementId ? this.elementId : 'datetimerange-input1'" class="form-control"></div>
</template>

<script>
import "/public/libs/datetimepicker/vanilla-datetimerange-picker.css"
import DateRangePicker from "/public/libs/datetimepicker/vanilla-datetimerange-picker"
import moment from "moment";

export default {
  name:'DateRangePicker',
  props:['elementId','changedDateRange'],
  mounted() {
    const chDr = this.changedDateRange

    new DateRangePicker(this.elementId ? this.elementId : 'datetimerange-input1',
        {
          showCustomRangeLabel:false,
          timePicker: true,
          alwaysShowCalendars: true,
          timePicker24Hour: true,
          ranges: {
            'დღეს': [moment().startOf('day'), moment().endOf('day')],
            'გუშინ': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
            'ბოლო 7 დღე': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
            'თვე': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
          },
          locale: {
            format: "YYYY.MM.DD",
          }
        },
        function (start, end) {

            if (chDr){
              let readedRange = {
                start:moment(start.format()).format('YY/MM/DD'),
                end:moment(end.format()).format('YY/MM/DD')
              }
              chDr(readedRange)
            }
        }

    )
  }
}
</script>